import angular from 'angular';
export class VideoSettingsHelper {
    constructor(VideoQualityService, currentUserHelper) {
        this.VideoQualityService = VideoQualityService;
        this.currentUserHelper = currentUserHelper;
    }
    canChangeVideoQuality(isPatient) {
        if (isPatient)
            return false;
        if (!this.VideoQualityService.canSwitchQuality())
            return false;
        return (this.currentUserHelper.user &&
            this.currentUserHelper.user.hasAccess('roomFeatures_changeVideoQuality'));
    }
}
export default angular
    .module('doxy.common.services.videoSettingsHelper', [])
    .service('videoSettingsHelper', VideoSettingsHelper).name;
